import { actions } from "./actions";
import axios from "axios";
import { urls } from "./urls";

const { baseUrlRestApi} = urls
export const dispatch = async (action: string, body?: Object, token?: string, headerParams?: any) => {
    try{
        let response = {} as any
    let axiosOptions = {} as any
    switch(action){
        case actions.signup: 
            axiosOptions =  getAxiosOptions("POST", `${baseUrlRestApi}/auth/signup`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.login:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/auth/login`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getUser:
            axiosOptions = getAxiosOptions("GET",  `${baseUrlRestApi}/user`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getStore:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/store/${headerParams.id}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getLogs:
            axiosOptions  = getAxiosOptions("GET", `${baseUrlRestApi}/logs/store/${headerParams.storeId}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.createStore:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/bot/createStore`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getStores:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/store`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getStoreProducts:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/product/store/${headerParams.storeId}`, body, token)
            response =  await axios(axiosOptions)
            return response.data
        case actions.createProductGroup:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/productGroup`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getStoreProductGroups:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/productGroup/store/${headerParams.storeId}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.editProduct:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/product/${headerParams.id}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.deleteProductGroup:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/productGroup/${headerParams.id}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.reInitiateStore:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/bot/reinitiateStore/${headerParams.id}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.deleteStore: 
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/bot/deleteStore/${headerParams.id}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.editProductGroup:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/productGroup/id/${headerParams.id}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getProductGroupProducts:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/product/productGroup/${headerParams.productGroupId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.addProduct: 
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/productGroup/addProduct/${headerParams.id}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.removeProduct:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/productGroup/removeProduct/${headerParams.productId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getProduct:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/product/${headerParams.id}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.addProducts:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/productGroup/addProducts/${headerParams.id}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAllProductGroupProducts:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/product/get/all`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.clearLog:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/logs/store/${headerParams.storeId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAnalytics:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/product/analytics/productGroup`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAnalyticsProduct: 
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/product/analytics/product`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAnalyticsAll:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/product/analytics/all`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getShipmentProviders:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/store/get/shipmentproviders/${headerParams.storeId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.startPendingBot:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/store/start/pendingbot/${headerParams.storeId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.stopPendingBot:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/store/stop/pendingbot/${headerParams.storeId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.addReadyToShipBotEmail:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/store/readytoshipbot/add/email/${headerParams.storeId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.deleteReadyToShipBotEmail:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/store/readytoshipbot/delete/email/${headerParams.storeId}/${headerParams.email}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.addXlsxBotEmail:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/store/xlsxbot/add/email/${headerParams.storeId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.deleteXlsxBotEmail:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/store/xlsxbot/delete/email/${headerParams.storeId}/${headerParams.email}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.startReadyToShipBot:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/store/start/readytoshipbot/${headerParams.storeId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.stopReadyToShipBot:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/store/stop/readytoshipbot/${headerParams.storeId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.stopStore:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/store/stop/orderbot/${headerParams.storeId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getActionLogs:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/actionlog`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.saveActionLog:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/actionlog`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.deleteActionLog:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/actionlog/${headerParams.id}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getTokenHealth:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/store/token-health`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.refreshTokens:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/store/refresh-tokens`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getJumiaPrice:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/product/jumia-price/${headerParams.storeId}/${headerParams.sku}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.updateJumiaPrice:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/product/jumia-price/update/${headerParams.storeId}/${headerParams.sku}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getTrackedSkus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/user/tracked-skus`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.addTrackedSku:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/user/tracked-skus`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.removeTrackedSku:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/user/tracked-skus/${headerParams.productId}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.updateTrackedSkuReason:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/user/tracked-skus/${headerParams.productId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getStockIntelligence:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/product/stock-intelligence`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getInventorySummary:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/inventory/summary?storeId=${(headerParams?.storeId) || "0"}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.addInventoryMovement:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/inventory/movement`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.purchaseInventory:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/inventory/purchase`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.importInventory:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/inventory/import`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getInventoryImports:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/inventory/imports`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.updateInventoryStock:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/inventory/stock/${headerParams.groupId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.inventoryPackGet:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/inventory/pack/${headerParams.groupId}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.inventoryPackSave:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/inventory/pack/${headerParams.groupId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.inventoryMinProfit:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/inventory/min-profit/${headerParams.groupId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.inventoryPackCandidates:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/inventory/packs/candidates`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.updateInventorySyncSettings:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/inventory/sync-settings/${headerParams.groupId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.syncGroupToJumia:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/inventory/sync-jumia/${headerParams.groupId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.syncAllToJumia:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/inventory/sync-jumia-all`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getJumiaSyncAllStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/inventory/sync-jumia-all/status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.syncGroupToMarjan:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/inventory/sync-marjan/${headerParams.groupId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.syncAllToMarjan:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/inventory/sync-marjan-all`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanSyncAllStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/inventory/sync-marjan-all/status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.updateMarketInfo:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/inventory/market-update/${headerParams.groupId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getUnassociatedSkus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/productGroup/unassociated?storeId=${headerParams?.storeId||""}&search=${headerParams?.search||""}&since=${encodeURIComponent(headerParams?.since||"")}&until=${encodeURIComponent(headerParams?.until||"")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAssociatedSkus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/productGroup/associated?storeId=${headerParams?.storeId||""}&since=${encodeURIComponent(headerParams?.since||"")}&until=${encodeURIComponent(headerParams?.until||"")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getGroupsDetail:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/productGroup/all-detail?since=${encodeURIComponent(headerParams?.since||"")}&until=${encodeURIComponent(headerParams?.until||"")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getSkuSuggestions:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/productGroup/suggestions/${headerParams.productId}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.bulkAssignSkus:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/productGroup/bulk-assign`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.moveSkuToGroup:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/productGroup/move-product/${headerParams.productId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAssociationHistory:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/productGroup/history?limit=${headerParams?.limit||50}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.setGroupImageFromSku:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/productGroup/image-from-sku/${headerParams.groupId}/${headerParams.productId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoFixGroupImages:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/productGroup/auto-fix-images`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getSkusByGroup:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/productGroup/skus-by-group/${headerParams.groupId}?since=${encodeURIComponent(headerParams?.since||"")}&until=${encodeURIComponent(headerParams?.until||"")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.searchAllSkus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/productGroup/search-skus?search=${encodeURIComponent(headerParams?.search||"")}&storeId=${headerParams?.storeId||""}&since=${encodeURIComponent(headerParams?.since||"")}&until=${encodeURIComponent(headerParams?.until||"")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.startAutoAssociate:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/catalog/auto-associate`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAutoAssociateStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/catalog/auto-associate-status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getPendingAssociations:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/catalog/pending-associations?confidence=${headerParams?.confidence||""}&page=${headerParams?.page||0}&limit=${headerParams?.limit||60}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.applyPendingAssociations:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/catalog/apply-associations`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.clearPendingAssociations:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/catalog/pending-associations`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAutoPilotOverview:
            {
                const qs = new URLSearchParams()
                if (headerParams?.storeId && headerParams.storeId !== "0") qs.set("storeId", headerParams.storeId)
                if (headerParams?.page != null) qs.set("page", String(headerParams.page))
                if (headerParams?.limit) qs.set("limit", String(headerParams.limit))
                if (headerParams?.phase) qs.set("phase", headerParams.phase)
                if (headerParams?.q) qs.set("q", headerParams.q)
                if (headerParams?.refresh) qs.set("refresh", "1")
                axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/autopilot/overview?${qs.toString()}`, {}, token)
            }
            response = await axios(axiosOptions)
            return response.data
        case actions.marjanPilotStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/autopilot/marjan-pilot`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.marjanPilotSet:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/marjan-pilot`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.jumiaFeesStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/autopilot/jumia-fees`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.jumiaFeesImport:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/jumia-fees/import`, body, token)
            response = await axios({ ...axiosOptions, timeout: 300000 })
            return response.data
        case actions.saveAutoPilotSettings:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/settings`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotEnroll:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/skus`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotToggle:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/skus/toggle`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotRemove:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/skus/remove`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotReset:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/skus/reset`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotPreview:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/preview`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotRun:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/run`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAutoPilotRunStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/autopilot/run-status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAutoPilotRuns:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/autopilot/runs?limit=${headerParams?.limit || 20}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAutoPilotSku:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/autopilot/skus/${headerParams.id}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAutoPilotRun:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/autopilot/runs/${headerParams.id}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getListingIssues:
            {
                const qs = new URLSearchParams()
                if (headerParams?.storeId && headerParams.storeId !== "0") qs.set("storeId", headerParams.storeId)
                if (headerParams?.days) qs.set("days", String(headerParams.days))
                axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/autopilot/listing-issues?${qs.toString()}`, {}, token)
            }
            response = await axios(axiosOptions)
            return response.data
        case actions.recheckListingIssues:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/listing-issues/recheck`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAutoPilotWinners:
            {
                const qs = new URLSearchParams()
                if (headerParams?.storeId && headerParams.storeId !== "0") qs.set("storeId", headerParams.storeId)
                if (headerParams?.all) qs.set("all", "1")
                axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/autopilot/winners?${qs.toString()}`, {}, token)
            }
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotWinnersDetect:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/winners/detect`, body || {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotWinnersScan:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/winners/scan`, body || {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAutoPilotWinnerScanStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/autopilot/winners/scan-status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotWinnersAdd:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/winners/add`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotWinnersRemove:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/winners/remove`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotWinnerUpdate:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/winners/${headerParams.id}/update`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotWinnerComparable:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/winners/${headerParams.id}/comparable`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.autoPilotWinnerTestSearch:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/autopilot/winners/test-search`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getRadarOverview:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/radar/overview`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getRadarTree:
            {
                const qs = new URLSearchParams()
                if (headerParams?.parent) qs.set("parent", headerParams.parent)
                if (headerParams?.q) qs.set("q", headerParams.q)
                axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/radar/tree?${qs.toString()}`, {}, token)
            }
            response = await axios(axiosOptions)
            return response.data
        case actions.radarTreeExpand:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/radar/tree/expand`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.radarTreeCrawl:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/radar/tree/crawl`, body || {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.radarCheckWatch:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/radar/watches/check`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.radarAddWatch:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/radar/watches`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.radarUpdateWatch:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/radar/watches/${headerParams.id}/update`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.radarRemoveWatches:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/radar/watches/remove`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.radarScan:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/radar/scan`, body || {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getRadarScanStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/radar/scan-status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getRadarPicks:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/radar/picks`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.saveRadarPicksSettings:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/radar/picks/settings`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.radarPicksDetectChat:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/radar/picks/detect-chat`, body || {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.radarPicksPreview:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/radar/picks/preview`, body || {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.radarPicksRun:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/radar/picks/run`, body || {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.radarPickStatus:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/radar/picks/${headerParams.id}/status`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getRadarListings:
            {
                const qs = new URLSearchParams()
                if (headerParams?.watchId) qs.set("watchId", headerParams.watchId)
                if (headerParams?.mode) qs.set("mode", headerParams.mode)
                if (headerParams?.q) qs.set("q", headerParams.q)
                if (headerParams?.page != null) qs.set("page", String(headerParams.page))
                if (headerParams?.limit) qs.set("limit", String(headerParams.limit))
                for (const k of ["priceMin","priceMax","ratingMin","ratingMax","reviewsMin","reviewsMax","rankMin","rankMax","revWeekMin","ours","express","sortBy","sortDir"]) {
                    const v = headerParams?.[k]
                    if (v !== undefined && v !== null && v !== "") qs.set(k, String(v))
                }
                axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/radar/listings?${qs.toString()}`, {}, token)
            }
            response = await axios(axiosOptions)
            return response.data
        case actions.getPricingOpportunities:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/opportunities`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.simulatePricing:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/simulate`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.applyPrice:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/apply`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.bulkApplyPrices:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/bulk-apply`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getBulkApplyStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/bulk-status/${headerParams.jobId}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getPricingLogs:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/logs?limit=${headerParams?.limit||50}&page=${headerParams?.page||0}${headerParams?.status ? `&status=${headerParams.status}` : ""}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getPricingSettings:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/settings`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.savePricingSettings:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/settings`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.syncPrices:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/sync-prices`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getSyncStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/sync-status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.startCatalogScan:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/catalog/scan`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getCatalogScanStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/catalog/scan-status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.liveSyncSkus:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/live-sync`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.syncStock:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/sync-stock`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getStockSyncStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/stock-sync-status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.bulkUpdateStock:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/pricing/bulk-update-stock`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getBulkStockStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/pricing/bulk-status/${headerParams.jobId}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.mergeGroups:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/productGroup/merge`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.cleanupEmptyGroups:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/productGroup/cleanup-empty`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        // ── Auth extras ──────────────────────────────────────────────────────
        case actions.forgotPassword:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/auth/forgot-password`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.resetPassword:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/auth/reset-password/${headerParams.token}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        // ── Admin user management ─────────────────────────────────────────────
        case actions.getAdminUsers:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/admin/users`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.approveUser:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/admin/users/${headerParams.userId}/approve`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.denyUser:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/admin/users/${headerParams.userId}/deny`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.updateUserPermissions:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/admin/users/${headerParams.userId}/permissions`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.deleteAdminUser:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/admin/users/${headerParams.userId}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.adminResetPassword:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/admin/users/${headerParams.userId}/reset-password`, body, token)
            response = await axios(axiosOptions)
            return response.data
        // ── Buying Decisions ──────────────────────────────────────────────────
        case actions.getBuyingDecisions:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/inventory/buying-decisions`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        // ── Marjan (Octopia) ──────────────────────────────────────────────────
        case actions.getMarjanStores:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/stores`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.createMarjanStore:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/stores`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.updateMarjanStore:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/marjan/stores/${headerParams.id}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.deleteMarjanStore:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/marjan/stores/${headerParams.id}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.testMarjanStore:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/stores/${headerParams.id}/test`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanOverview:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/stores/${headerParams.id}/overview?days=${headerParams.days || 30}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanOrders:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/stores/${headerParams.id}/orders?page=${headerParams.page || 1}&days=${headerParams.days || 30}${headerParams.status ? `&status=${headerParams.status}` : ''}${headerParams.q ? `&q=${encodeURIComponent(headerParams.q)}` : ''}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.syncMarjanStore:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/stores/${headerParams.id}/sync`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanSyncStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/stores/${headerParams.id}/sync-status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.updateMarjanStock:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/stores/${headerParams.id}/stock`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.updateMarjanPrice:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/stores/${headerParams.id}/price`, body, token)
            response = await axios(axiosOptions)
            return response.data
        // ── Marjan finance (payouts / profit) ─────────────────────────────────
        case actions.syncMarjanFinance:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/stores/${headerParams.id}/finance/sync`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanFinanceStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/stores/${headerParams.id}/finance/status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanPayouts:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/stores/${headerParams.id}/payouts`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanPayoutLines:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/stores/${headerParams.id}/payouts/${encodeURIComponent(headerParams.echeance)}/lines${headerParams.store ? `?store=${headerParams.store}` : ''}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanProfit:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/stores/${headerParams.id}/profit?days=${headerParams.days || 30}&basis=${headerParams.basis || 'transaction'}${headerParams.from ? `&from=${headerParams.from}&to=${headerParams.to}` : ''}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanProducts:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/products${headerParams?.storeId ? `?storeId=${headerParams.storeId}` : ''}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanGroups:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/groups`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanLinkSuggestions:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/links/suggestions?title=${encodeURIComponent(headerParams.title || '')}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.setMarjanLink:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/marjan/links/${encodeURIComponent(headerParams.sku)}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.removeMarjanLink:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/marjan/links/${encodeURIComponent(headerParams.sku)}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        // ── Marjan SKU association ────────────────────────────────────────────
        case actions.getMarjanAssocSkus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/association/skus?mode=${headerParams?.mode || 'all'}&search=${encodeURIComponent(headerParams?.search || '')}&storeId=${headerParams?.storeId || ''}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanAssocGroups:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/association/groups`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanAssocByGroup:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/association/skus-by-group/${headerParams.groupId}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.marjanBulkLink:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/association/bulk-link`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.marjanApplySuggestions:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/association/apply-suggestions`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.marjanUnlink:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/marjan/association/link/${encodeURIComponent(headerParams.sku)}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.marjanCreateGroup:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/association/create-group`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.marjanAutoSuggest:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/association/auto-suggest`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.marjanSyncImages:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/association/sync-images`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.marjanAutoAssociateStart:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/association/auto-associate`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.marjanAutoAssociateStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/association/auto-associate-status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanPending:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/association/pending?confidence=${headerParams?.confidence || ''}&page=${headerParams?.page || 0}&limit=${headerParams?.limit || 200}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.retargetMarjanPending:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/marjan/association/pending/${headerParams.id}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.applyMarjanPending:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/association/pending/apply`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.clearMarjanPending:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/marjan/association/pending`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanBelowCost:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/association/below-cost`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.confirmMarjanBelowCost:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/marjan/association/below-cost/${encodeURIComponent(headerParams.sku)}/confirm`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getMarjanAssocHistory:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/marjan/association/history`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        // ── Net Profit ────────────────────────────────────────────────────────
        case actions.getProfitSummary:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/profit/summary`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getProfitMonthly:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/profit/monthly?months=${headerParams?.months || 12}&storeId=${headerParams?.storeId || "0"}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getProfitTodayEstimate:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/profit/today-estimate?storeId=${headerParams?.storeId || "0"}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getAutoPilotVerdict:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/profit/autopilot-verdict`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getProfitCategories:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/profit/categories`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getExpenses:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/profit/expenses`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.createExpense:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/profit/expenses`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.updateExpense:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/profit/expenses/${headerParams.id}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.deleteExpense:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/profit/expenses/${headerParams.id}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getProfitSettings:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/profit/settings`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.saveProfitSettings:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/profit/settings`, body, token)
            response = await axios(axiosOptions)
            return response.data
        // ── Warehouse ─────────────────────────────────────────────────────
        case actions.getWarehouseSlotting:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/warehouse/slotting`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.getWarehouseMap:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/warehouse/map`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.generateWarehouseLocations:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/warehouse/locations/generate`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.createWarehouseLocation:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/warehouse/locations`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.updateWarehouseLocation:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/warehouse/locations/${headerParams.id}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.deleteWarehouseLocation:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/warehouse/locations/${headerParams.id}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.assignWarehouseSlot:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/warehouse/assign/${headerParams.groupId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.assignWarehouseBulk:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/warehouse/assign-bulk`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.buildWarehousePlan:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/warehouse/plan`, body, token)
            response = await axios(axiosOptions)
            return response.data
        // PDFs come back as blobs — the page opens them in a new tab for printing
        case actions.warehousePlanPdf:
            axiosOptions = { ...getAxiosOptions("POST", `${baseUrlRestApi}/warehouse/plan/pdf`, body, token), responseType: "blob" }
            response = await axios(axiosOptions)
            return { blob: response.data }
        case actions.warehouseLocationLabels:
            axiosOptions = { ...getAxiosOptions("POST", `${baseUrlRestApi}/warehouse/labels/locations`, body, token), responseType: "blob" }
            response = await axios(axiosOptions)
            return { blob: response.data }
        case actions.getWarehouseMoves:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/warehouse/moves`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.snoozeWarehouseMove:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/warehouse/moves/${headerParams.groupId}/snooze`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.warehouseProductLabels:
            axiosOptions = { ...getAxiosOptions("POST", `${baseUrlRestApi}/warehouse/labels/products`, body, token), responseType: "blob" }
            response = await axios(axiosOptions)
            return { blob: response.data }
        // ── Jumia product listing ──
        case actions.listingCategories:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/categories?q=${encodeURIComponent(headerParams?.q || "")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingCategoriesSync:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/categories/sync`, body || {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingBrands:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/brands?q=${encodeURIComponent(headerParams?.q || "")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingBrandsSync:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/brands/sync`, body || {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingBrandSuggest:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/brand-suggest`, body || {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingMarjanCatRefresh:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/marjan/categories/refresh`, body || {}, token)
            response = await axios({ ...axiosOptions, timeout: 120000 })
            return response.data
        case actions.listingMarjanEans:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/marjan/eans`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingMarjanEansUpload:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/marjan/eans`, body || {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingMarjanReference:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/marjan/reference${headerParams?.check ? `?check=${encodeURIComponent(headerParams.check)}` : ""}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingGroups:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/groups?q=${encodeURIComponent(headerParams?.q || "")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingAiImport:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/ai/import`, body || {}, token)
            response = await axios({ ...axiosOptions, timeout: 180000 })
            return response.data
        case actions.listingAiContent:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/ai/content`, body || {}, token)
            response = await axios({ ...axiosOptions, timeout: 300000 })
            return response.data
        case actions.listingAiUsage:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/ai/usage`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingAiBudget:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/ai/usage`, body || {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingMarjanCategories:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/marjan/categories?storeId=${headerParams?.storeId || ""}&q=${encodeURIComponent(headerParams?.q || "")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingMarjanAttributes:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/marjan/categories/${headerParams.categoryId}/attributes?storeId=${headerParams?.storeId || ""}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingMarjanBrands:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/marjan/brands?storeId=${headerParams?.storeId || ""}&q=${encodeURIComponent(headerParams?.q || "")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingMarjanGtin:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/marjan/gtin?storeId=${headerParams?.storeId || ""}&gtin=${encodeURIComponent(headerParams?.gtin || "")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingPublish:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/${headerParams.id}/publish`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingSyncStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/sync-status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingAttributeSet:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/attribute-set/${headerParams.sid}?storeId=${headerParams?.storeId || ""}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingImages:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/images`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingImageFromUrl:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/images/from-url`, body, token)
            response = await axios({ ...axiosOptions, timeout: 60000 })
            return response.data
        case actions.listingSource:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/source?storeId=${headerParams.storeId}&sku=${encodeURIComponent(headerParams.sku)}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingPreview:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/preview`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingCreate:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/create`, body, token)
            response = await axios({ ...axiosOptions, timeout: 600000 })   // Marjane creation embeds 6 pictures per store
            return response.data
        case actions.listingList:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing?storeId=${headerParams?.storeId || ""}&channel=${headerParams?.channel || ""}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingStats:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/stats?days=${headerParams?.days || 30}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingCoverage:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/coverage${headerParams?.refresh ? "?refresh=1" : ""}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingGroupCoverage:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/group-coverage/${headerParams.groupId}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingCategorySuggest: {
            const q = new URLSearchParams({ groupId: headerParams?.groupId || "", storeId: headerParams?.storeId || "", channel: headerParams?.channel || "jumia", current: headerParams?.current || "", title: headerParams?.title || "" })
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/category-suggestions?${q}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        }
        case actions.listingRotateCategories:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/rotate-categories`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingStrategies:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/strategies`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingStrategyAction:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/strategies/${encodeURIComponent((body as any).key)}/action`, { action: (body as any).action }, token)
            response = await axios({ ...axiosOptions, timeout: 900000 })
            return response.data
        case actions.spreadStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/spread/status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.spreadPlan:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/spread/plan`, body, token)
            response = await axios({ ...axiosOptions, timeout: 300000 })
            return response.data
        case actions.spreadSettings:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/spread/settings`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.spreadRunStore:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/spread/run-store`, body, token)
            response = await axios({ ...axiosOptions, timeout: 900000 })
            return response.data
        case actions.listingCategoryAi:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/category-suggestions/ai`, body, token)
            response = await axios({ ...axiosOptions, timeout: 200000 })
            return response.data
        case actions.listingRecentCreations:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/recent-creations?groupId=${headerParams?.groupId || ""}&hours=${headerParams?.hours || 24}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.decisionsList:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/profit/decisions?days=${headerParams?.days || 14}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.decisionsDaily:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/profit/decisions/daily?days=${headerParams?.days || 90}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.decisionCreate:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/profit/decisions?days=${headerParams?.days || 14}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.decisionDelete:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/profit/decisions/${headerParams.id}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.decisionGroups:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/profit/decisions/groups?q=${encodeURIComponent(headerParams?.q || "")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.weeklyReports:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/profit/weekly-reports`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.weeklyReport:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/profit/weekly-reports/${headerParams.week}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.weeklyReportRun:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/profit/weekly-reports/run`, body, token)
            response = await axios({ ...axiosOptions, timeout: 180000 })
            return response.data
        case actions.listingSuggestSku:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/listing/suggest-sku?storeId=${headerParams.storeId}&title=${encodeURIComponent(headerParams.title || "")}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingRetry:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/${headerParams.id}/retry`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        // ── Returns & claims ──
        case actions.returnsCases: {
            const qs = new URLSearchParams(Object.entries(headerParams || {}).filter(([, v]) => v != null && v !== "").map(([k, v]) => [k, String(v)])).toString()
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/returns/cases?${qs}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        }
        case actions.returnsSummary:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/returns/summary?days=${headerParams?.days || 120}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.returnsManifest:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/returns/manifest`, body, token)
            response = await axios({ ...axiosOptions, timeout: 360000 })
            return response.data
        case actions.returnsTracking:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/returns/tracking?days=${headerParams?.days || 60}${headerParams?.marketplace ? `&marketplace=${headerParams.marketplace}` : ""}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.returnsStores:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/returns/stores`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.returnsSync:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/returns/sync`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.returnsUpdate:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/returns/cases/${headerParams.id}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.returnsDraftClaim:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/returns/cases/${headerParams.id}/claim/draft`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.returnsSendClaim:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/returns/cases/${headerParams.id}/claim/send`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.returnsMarjanTickets:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/returns/marjan/tickets?storeId=${headerParams?.storeId || "all"}${headerParams?.force ? "&force=1" : ""}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.returnsConfig:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/returns/config`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.listingRefresh:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/listing/${headerParams.id}/refresh`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        // ── Daily Shipments ──
        case actions.handoverDays:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/handover/days?from=${headerParams?.from || ""}&to=${headerParams?.to || ""}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.handoverDay:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/handover/day/${headerParams.day}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.handoverAddSheet:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/handover/day/${headerParams.day}/sheets`, body, token)
            response = await axios({ ...axiosOptions, timeout: 360000 })
            return response.data
        case actions.handoverRerunSheet:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/handover/day/${headerParams.day}/sheets/${headerParams.sheetId}/rerun`, {}, token)
            response = await axios({ ...axiosOptions, timeout: 360000 })
            return response.data
        case actions.handoverAddRow:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/handover/day/${headerParams.day}/sheets/${headerParams.sheetId}/rows`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.handoverUpdateRow:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/handover/day/${headerParams.day}/sheets/${headerParams.sheetId}/rows/${headerParams.rowId}`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.handoverDeleteSheet:
            axiosOptions = getAxiosOptions("DELETE", `${baseUrlRestApi}/handover/day/${headerParams.day}/sheets/${headerParams.sheetId}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.handoverNotes:
            axiosOptions = getAxiosOptions("PUT", `${baseUrlRestApi}/handover/day/${headerParams.day}/notes`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.handoverApply:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/handover/day/${headerParams.day}/apply`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.handoverUndo:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/handover/day/${headerParams.day}/undo`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.handoverBackfill:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/handover/backfill`, body, token)
            response = await axios(axiosOptions)
            return response.data
        // ── My Store (Shopify) ──
        case actions.shopifyStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/shopify/status`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.shopifyCandidates:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/shopify/candidates?days=${headerParams?.days || 90}&minDelivered=${headerParams?.minDelivered || 8}`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.shopifyProducts:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/shopify/products`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.shopifySync:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/shopify/sync`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.shopifySyncStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/shopify/sync`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.shopifyProductStatus:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/shopify/products/${headerParams.id}/status`, body, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.shopifyProductRefresh:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/shopify/products/${headerParams.groupId}/refresh`, body, token)
            response = await axios({ ...axiosOptions, timeout: 120000 })
            return response.data
        case actions.shopifyPushStock:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/shopify/stock/push-all`, {}, token)
            response = await axios({ ...axiosOptions, timeout: 300000 })
            return response.data
        case actions.shopifyRegisterWebhooks:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/shopify/webhooks/register`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.shopifyArabic:
            axiosOptions = getAxiosOptions("POST", `${baseUrlRestApi}/shopify/arabic`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.shopifyArabicStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/shopify/arabic`, {}, token)
            response = await axios(axiosOptions)
            return response.data
        case actions.handoverBackfillStatus:
            axiosOptions = getAxiosOptions("GET", `${baseUrlRestApi}/handover/backfill`, {}, token)
            response = await axios(axiosOptions)
            return response.data
    }
    }
    catch(err: any){
        console.log(err)
        return err.response.data
    }
}
const getAxiosOptions = (method: string, url: string, body?: Object, token?: string) => {
    const headers = {
        "x-auth-token": token ? token : "",
        "Content-Type": "application/json",
    };
    switch (method) {
        case "GET":
            return {
                method: "GET",
                url,
                headers,
            };
            break;
        case "POST":
            return {
                method: "POST",
                url,
                headers,
                data: body,
            };
            break;
        case "PUT":
            return {
                method: "PUT",
                url,
                headers,
                data: body,
            };
            break;
        case "DELETE":
            return {
                method: "DELETE",
                url,
                headers,
            };
            break;
    }
};
